/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css } from "@panda/css";

export const Divider = (): React.JSX.Element => {
	return (
		<div
			className={css({
				width: "1px",
				borderInlineStartWidth: "1px",
				borderInlineStartStyle: "solid",
				borderInlineStartColor: "eds.border.subtle",
				xsOnly: {
					width: "100%",
					height: "1px",
					borderTopWidth: "1px",
					borderTopStyle: "solid",
					borderTopColor: "eds.border.subtle",
				},
			})}
		></div>
	);
};
